import React from 'react';
import PropTypes from 'prop-types';
import { Icon, Popup } from 'semantic-ui-react';

import CurrentlyOpenLabel from './CurrentlyOpenLabel';

export default function HoursOfOperationDailyWithPopup(props) {
  const { displayOpenClosedStatus, timezone, hours, children, label, secondaryLabel } = props;

  let visibleFirstDay;
  if (displayOpenClosedStatus && timezone) {
    visibleFirstDay = (
      <div className="hoo-withpopup-first">
        <CurrentlyOpenLabel hours={hours} timezone={timezone} />
        <Icon name="caret down" />
      </div>
    );
  } else {
    visibleFirstDay = (
      <div className="hoo-withpopup-first">
        <h4>{label}</h4>
        <p className="hoo-hours-paragraph">{secondaryLabel}</p>
        <Icon name="caret down" />
      </div>
    );
  }

  return <Popup trigger={visibleFirstDay} content={children} basic on="click" />;
}

HoursOfOperationDailyWithPopup.propTypes = {
  displayOpenClosedStatus: PropTypes.bool.isRequired,
  timezone: PropTypes.string,
  hours: PropTypes.arrayOf(PropTypes.any),
  children: PropTypes.element.isRequired,
  label: PropTypes.string,
  secondaryLabel: PropTypes.string,
};

HoursOfOperationDailyWithPopup.defaultProps = {
  timezone: '',
  hours: [],
  label: 'See hours',
  secondaryLabel: '',
};
